import { FORMAT_C3_YEAR_DATE } from '@cube3/common/model/schema/resources/metadata-field';
import { yearParser } from './makeParser';

export const multipleFieldRegexp = /multiple/; // /multiple\(.*?\)/;

export const hydrateValue = (value, type, skipJson = false) => {
  // TODO: update when this is done serverside and/or add multi-select
  let parsed = value;


  if (!skipJson) {
    try {
      parsed = JSON.parse(value);
    } catch (e) {
      console.warn(`tried to parse value ${value} of type ${type}`);
    }
  }

  console.info("DEBUG hydrate", { value, parsed, type, })

  switch (true) {
    case type === 'waterfall_select':
      if (typeof parsed === 'string') {
        parsed = JSON.parse(parsed);
      }
      return { value: parsed };
    case type === 'text' || type === 'string' || type === 'textarea':
      return parsed.toString();
    case type === 'asset':
      return parsed.toString().split(',');

    case type === 'checkbox' && value && typeof value === 'string':
      if (parsed === 'true' || parsed === 'false') {
        return JSON.parse(value);
      } else {
        return value.split(',')
      }


    default:
      return parsed;
  }
};

export const dehydrateValue = (value, type, schema) => {
  // TODO: update when this is done serverside and/or add multi-select
  let formated;
  switch (true) {
    case type === 'date' &&
      schema &&
      JSON.parse(schema)?.format === FORMAT_C3_YEAR_DATE:
      formated = yearParser(value);
      break;
    case type === 'waterfall_select':
      formated = value?.value;
      break;
    case type === 'text' || type === 'string' || type === 'textarea':
      formated = value.toString().trim();
      break;

    case type === 'checkbox':
      if (typeof value === 'boolean') {
        formated = JSON.stringify(value)
      } else {
        formated = value.join(',')
      }
      break

    default:
      formated = value;
      break;
  }

  return formated;
};
